// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Navigation from '../../../common/Navigation/Navigation';
import styles from './styles';

const NotFoundPage = ({ classes }) => (
  <Navigation>
    <div className={classes.mainContainer}>
      <h1>NOT FOUND</h1>
      <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
    </div>
  </Navigation>
);

NotFoundPage.propTypes = {
  classes: PropTypes.object,
};

NotFoundPage.defaultProps = {
  classes: {},
};

export default withStyles(styles)(NotFoundPage);
